import React from "react";
import { Dialog, DialogTitle, DialogContent } from "@mui/material";
import { Tab, Tabs } from "react-bootstrap";

interface TabItem {
  key: string;
  title: string;
  content: React.ReactNode;
}

interface CustomDialogProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  tabs: TabItem[];
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl";
}

const CustomDialog: React.FC<CustomDialogProps> = ({
  isOpen,
  onClose,
  title,
  tabs,
  maxWidth = "sm",
}) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      fullWidth
      maxWidth={maxWidth}
      PaperProps={{
        style: { borderRadius: "10px" },
      }}
    >
      <DialogTitle
        sx={{
          backgroundColor: "#194e5b",
          color: "white",
          borderTopLeftRadius: "10px",
          borderTopRightRadius: "10px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {title}
        <i
          className="bi bi-x"
          style={{ cursor: "pointer" }}
          onClick={onClose}
        ></i>
      </DialogTitle>
      <DialogContent sx={{ marginTop: "10px", padding: "20px" }}>
        <Tabs
          defaultActiveKey={tabs[0]?.key}
          id="custom-dialog-tabs"
          className="mb-3"
        >
          {tabs.map((tab) => (
            <Tab eventKey={tab.key} title={tab.title} key={tab.key}>
              <div className="p-2 h-[350px] overflow-y-auto">
                {tab.content}
              </div>
            </Tab>
          ))}
        </Tabs>
      </DialogContent>
    </Dialog>
  );
};

export default CustomDialog;
